import { useEffect, useState } from 'react';

import { localStore } from '~src/state/local';
import { useLocation } from './useLocation';

export const LEAD_ORIGIN_NORLYS = 'norlys';
export const LEAD_ORIGIN_DISTRICT_HEATING_FLYER = 'dhflyer';

export type LeadOrigin = 'nordea' | 'norlys' | 'edc' | 'bodil' | 'cdm' | 'jyskebank' | string;
export const ORIGINS: LeadOrigin[] = [LEAD_ORIGIN_NORLYS, 'nordea', 'edc', 'bodil', 'cdm', 'jyskebank'];

export const useLeadOrigin = () => {
  const [leadOrigin, setLeadOrigin] = useState<LeadOrigin>();
  const [loading, setLoading] = useState(true);

  const { location, parameters } = useLocation();
  const { href } = location ?? {};

  const updateLeadOrigin = (origin: LeadOrigin) => {
    localStore().set('leadOrigin', origin);
    setLeadOrigin(origin);
  };

  useEffect(() => {
    setLoading(false);

    const fromParameter = parameters?.get('leadOrigin') ?? undefined;

    if (fromParameter && ORIGINS.includes(fromParameter)) {
      updateLeadOrigin(fromParameter);
      return;
    }

    const fromURL = ORIGINS.find(name => href?.includes(name));

    if (fromURL) {
      updateLeadOrigin(fromURL);
      return;
    }

    const current = localStore().get('leadOrigin');
    setLeadOrigin(current ?? undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { origin: leadOrigin, loading };
};
